"use strict";

const tabs = Object.freeze({
    TENANCY_CUSTOMIZATION: {
        name: "tenancycustomization",
        description: "Tenancy Customization",
    },
    BUSINESS_AREAS: {
        name: "businessareas",
        description: "Business Areas",
    },
    BUSINESS_AREA_DATA: {
        name: "businessareadata",
        description: "Business Area Data",
    },
    DATA_CLASSIFIERS: {
        name: "dataclassifiers",
        description: "Data Classifier Tags",
    },
    ROLES: {
        name: "roles",
        description: "Roles",
    },
    /*  {
         name: "rolegroups",
         description: "Role Groups"
     }, */
    USERS: {
        name: "users",
        description: "Users",
    },
    API_KEYS: {
        name: "apikeys",
        description: "API Keys",
    },
    /* {
        name: "usergroups",
        description: "User Groups"
    }, */
    SYSTEM_CONNECTIONS: {
        name: "systemconnections",
        description: "System Connections",
    },
    SYSTEM_KEYS: {
        name: "systemkeys",
        description: "System Keys",
    },
    AI_MODEL_ROUTING: {
        name: "aimodelrouting",
        description: "AI Model Routing",
    },
    AI_USAGE: {
        name: "aiusage",
        description: "AI Usage & Cost",
    },
    CHANGE_DATA_CAPTURE: {
        name: "changedatacapture",
        description: "CDC Destinations",
    },
    DATA_SYNDICATION_SOURCE: {
        name: "syndicationsource",
        description: "Syndication Sources",
    },
    DATA_SYNDICATION_SUBSCRIPTION: {
        name: "syndicationsubscription",
        description: "Syndication Subscriptions",
    },
});

module.exports = tabs;
